import React from 'react';
class ComingSoonModal extends React.Component {
  constructor(props){
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal(){
    this.props.removeModal();
  }

  render(){
    return (
      <div className="p-10 bg-fff container-rounded container-boxShadow">
        <a className="close-modal float-right" onClick={this.closeModal}><i className="icon-X_Close_Square"></i></a>
        <div className="text-center u-font-foundation-roman p-20 u-textSize-20">
          This section is under tender loving care.<br/>
            <span className="text-uppercase u-font-foundation-roman">coming soon</span>
        </div>
      </div>
    )
  }
}


export default ComingSoonModal;
